// const endPoint = process.env.NODE_ENV === 'development' ? 'https://dev.atnbookingengine.com/api' : 'https://www.atnbookingengine.com/api'
// const endPointV2 = process.env.NODE_ENV === 'development' ? 'https://dev.atnbookingengine.com/v2/api' : 'https://www.atnbookingengine.com/v2/api'
const endPoint = process.env.VUE_APP_API_BASE_URL
const endPointV2 = process.env.VUE_APP_API_BASE_URL_V2
const endPointV3 = process.env.VUE_APP_API_BASE_URL_V3
// app currency
export const currencies = `${endPoint}/getCurrencies`
// login
export const getUser = () => `${endPointV3}/auth/login`
export const signUp = () => `${endPointV3}/auth/register`
export const verifyEmail = () => `${endPointV3}/auth/email/verify`
export const requestResetPassword = () => `${endPointV3}/auth/reset-password-code`
export const resetPassword = () => `${endPointV3}/auth/reset-password`
export const forceResetPassword = () => `${endPointV3}/auth/force-change-password`
export const logOut = () => `${endPointV3}/auth/logout`
export const getOffices = () => `${endPoint}/offices/list`
// flights
export const getAirlines = (term) => `${endPointV2}/flights/airlines/autocomplete?term=${term}`
export const getAirports = (term) => `${endPoint}/airport/autocomplete?term=${term}`
export const searchFlights = (term) => `${endPoint}/flights/search?${term}`
export const getFlight = (id, search, relatedFlightId) => {
  if (relatedFlightId) {
    return `${endPoint}/flights?flight_id=${id}&search_id=${search}&related_flight_id=${relatedFlightId}`
  } else {
    return `${endPoint}/flights?flight_id=${id}&search_id=${search}`
  }
}
export const getServices = (flightID) => `${endPoint}/flights/service-catalog?flight_id=${flightID}`
export const getOffers = `${endPoint}/flights/service-list`
export const getSeats = `${endPoint}/flights/seat-map`
export const createPNR = `${endPoint}/pnr/create`
export const intentTK = `${endPoint}/pnr/intent-ticket`
export const issueTK = `${endPoint}/pnr/issue-ticket`
export const showPNR = (pnr) => `${endPoint}/pnr/${pnr}`
export const bookFlightByMail = `${endPointV2}/flights/send-special-offer-request-mail`
export const reportIssue = `${endPointV2}/utilities/report-issue`
export const quoteExchangeOffer = `${endPoint}/user/subAgent/tk/bookings/exchange/quote`
export const quoteIssue = `${endPoint}/user/subAgent/tk/bookings/quote`
export const userBooking = `${endPoint}/user/bookings`
export const updatePassportInfo = `${endPoint}/user/subAgent/tk/bookings/passenger/update-passport`
export const searchExchangeOffer = `${endPoint}/user/subAgent/tk/bookings/exchange/search`
export const refundPnr = `${endPoint}/user/subAgent/tk/bookings/refund/confirm`
export const preRefund = `${endPoint}/user/subAgent/tk/bookings/refund/quote`
export const profile = `${endPoint}/user/profile`
// >>export const issueRequest = `${endPoint}/`
export const issuePnr = `${endPoint}/user/subAgent/tk/bookings/issue`
export const checkExchangeValidity = `${endPoint}/user/subAgent/tk/bookings/exchange/validity`
export const confirmExchangeOffer = `${endPoint}/user/subAgent/tk/bookings/exchange/confirm`
export const cancelFlight = `${endPoint}/user/subAgent/tk/bookings/cancel`
// cars
export const carSearch = (term) => `${endPoint}/cars/search?${term}`
export const showCar = (term) => `${endPoint}/cars/show?${term}`
export const rentCar = `${endPoint}/cars/book`
export const mangeAgentEmails = `${endPoint}`
// hotels
export const getCities = (term) => `${endPoint}/cities/autocomplete?term=${term}`
export const searchHotels = (term) => `${endPoint}/hotels/search?${term}`
export const getHotel = (sessionId, hotelIndex, hotelCode) => `${endPoint}/hotels/show?sessionId=${sessionId}&hotelIndex=${hotelIndex}&hotelCode=${hotelCode}`
export const hotelAvailability = (term) => `${endPoint}/hotels/roomsAvailabilityAndPricing?${term}`
export const bookHotel = `${endPoint}/hotels/book`

// specialRquests

export const getspecialRequests = `${endPointV2}/flights/special-requests`
// headers
const correlationId = crypto.randomUUID()

export function headersNoAuth () {
  // return { Accept: 'application/json', 'Content-type': 'application/json', Application: 'https://tk-ndc.adamtravel.net', 'x-correlation-id': correlationId }
  // return { Accept: 'application/json', 'Content-type': 'application/json', 'x-correlation-id': correlationId }
  return {
    Accept: 'application/json',
    'Content-type': 'application/json',
    'x-correlation-id': correlationId,
    Application: 'https://tkndc.atsfares.com'
  }
  // return { Accept: 'application/json', 'Content-type': 'application/json', Application: 'http://localhost/tk' }
  // return { Accept: 'application/json', 'Content-type': 'application/json', Application: 'https://tkndc.atsfares.com' }
  // return { Accept: 'application/json', 'Content-type': 'application/json', Application: 'https://sabre-ndc.adamtravel.net' }
}

export function headersAuth (token) {
  return {
    Accept: 'application/json',
    'Content-type': 'application/json',
    'x-correlation-id': correlationId,
    Authorization: `Bearer ${token}`,
    Application: 'https://tkndc.atsfares.com'
  }
}

export function headerNoCorr () {
  return {
    Accept: 'application/json',
    'Content-type': 'application/json',
    Application: 'https://tkndc.atsfares.com'
  }
}
